(() => {
  const initialize=(scope=document)=>{
    const find=selector=>[...(scope.matches?.(selector)?[scope]:[]),...scope.querySelectorAll(selector)];
    find('[data-related-section]').forEach(section=>{
      if(section.dataset.mkNavigationReady)return;
      const carousel=section.querySelector('[data-related-carousel]'),nav=section.querySelector('[data-related-navigation]');
      if(!carousel||!nav)return;
      section.dataset.mkNavigationReady='true';
      const previous=nav.querySelector('[data-related-previous]'),next=nav.querySelector('[data-related-next]'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
      let frame=0;
      const update=()=>{
        frame=0;
        const max=carousel.scrollWidth-carousel.clientWidth,offset=Math.abs(carousel.scrollLeft);
        nav.hidden=max<3;
        previous.disabled=offset<3;
        next.disabled=offset>=max-3;
      };
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
      const move=direction=>{
        const card=carousel.querySelector('.mk-related-card'),rtl=getComputedStyle(carousel).direction==='rtl';
        const distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(carousel).columnGap||0);
        carousel.scrollBy({left:direction*distance*(rtl?-1:1),behavior:reduced.matches?'instant':'smooth'});
      };
      previous.addEventListener('click',()=>move(-1));
      next.addEventListener('click',()=>move(1));
      carousel.addEventListener('scroll',schedule,{passive:true});
      carousel.addEventListener('keydown',event=>{
        if(event.target!==carousel||!['ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();move(event.key==='ArrowRight'?1:-1);
      });
      new ResizeObserver(schedule).observe(carousel);
      update();
    });
    find('hdt-quantity-wrapp').forEach(wrapper=>{
      if(wrapper.dataset.mkQuantityReady)return;
      const input=wrapper.querySelector('input[type="number"]'),minus=wrapper.querySelector('[name="minus"]'),plus=wrapper.querySelector('[name="plus"]');
      if(!input||!minus||!plus)return;
      wrapper.dataset.mkQuantityReady='true';
      const sync=()=>{
        const quantity=Number(input.value),min=Number(input.min||1),max=input.max===''?Infinity:Number(input.max),step=Number(input.step||1);
        const cannotDecrease=input.disabled||!Number.isFinite(quantity)||quantity<=min;
        const cannotIncrease=input.disabled||!Number.isFinite(quantity)||quantity+step>max;
        if(minus.disabled!==cannotDecrease)minus.disabled=cannotDecrease;
        if(plus.disabled!==cannotIncrease)plus.disabled=cannotIncrease;
      };
      wrapper.addEventListener('input',sync);
      wrapper.addEventListener('change',sync);
      wrapper.addEventListener('click',()=>queueMicrotask(sync));
      new MutationObserver(sync).observe(wrapper,{subtree:true,attributes:true,attributeFilter:['min','max','step','disabled','class','value']});
      sync();
    });
  };
  const start=()=>{
    initialize();
    // Quick views and cart drawers insert fresh controls after the first page load.
    new MutationObserver(records=>{
      for(const record of records)for(const node of record.addedNodes){
        if(node.nodeType!==1)continue;
        if(node.matches('hdt-quantity-wrapp,[data-related-section]')||node.querySelector('hdt-quantity-wrapp,[data-related-section]'))initialize(node);
      }
    }).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:select',event=>initialize(event.target));
})();
